import styled from '@emotion/styled'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export const CrudPanelTitleWrapper = styled.div<{ extraMargin?: boolean }>`
  display: flex;
  -webkit-box-pack: justify;
  justify-content: space-between;
  background-color: rgb(244, 245, 250);
  padding: 0.75rem 0.81375rem 0.75rem 1.31375rem;
  margin-bottom: ${({ extraMargin }) => (extraMargin ? '1.5rem' : 'initial')};
`

export const CrudPanelTitle = styled.h6`
  font-size: 1.25rem;
  color: rgba(58, 53, 65, 0.87);
  padding: 0;
  margin: 0;
`

export const CrudPanelCloseIcon = styled(FontAwesomeIcon)`
  color: #989898;
  min-width: 50px;
  padding-top: 9px;
  text-align: center;
  font-size: 1.25rem;
  &:hover {
    color: #3c4043;
    cursor: pointer;
  }
`

export const CrudButtonNavigationWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 1.5rem;
`

export const ButtonsNavigation = styled.button<{ active: boolean }>`
  background-color: rgba(0, 92, 217, 0.14);
  border: none;
  flex-grow: 1;
  min-height: 50px;
  transition: background 0.8s;

  &:hover {
    background: rgba(0, 92, 217, 0.2)
      radial-gradient(circle, transparent 1%, rgba(0, 92, 217, 0.2) 1%)
      center/15000%;
    cursor: pointer;
  }

  &:active {
    background-color: rgba(0, 92, 217, 0.3);
    background-size: 100%;
    transition: background 0s;
  }

  &:focus {
    background-color: rgba(0, 92, 217, 0.3);
    border-bottom: 2px solid #005cd9;
  }

  ${({ active }) =>
    active &&
    `
    background-color: rgba(0, 92, 217,0.3);
    border-bottom: 2px solid #005cd9;
    
  `}
`

export const ButtonNavigationWrapper = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  padding: 8px;
  /* \${themeMediaQuery('small')} { */
  /*   padding: 0; */
  /* } */
`

export const ButtonNavigationIcons = styled(FontAwesomeIcon)`
  color: #005cd9;
  font-size: 2em;
  margin-right: 8px;
  max-width: 150px;
  /* \${themeMediaQuery('medium')} { */
  /*   font-size: 1.8em; */
  /* } */
  /* \${themeMediaQuery('small')} { */
  /*   font-size: 1em; */
  /* } */
`

export const ButtonNavigationTitle = styled.p`
  color: #005cd9;
  font-family: Roboto;
  font-size: 15px;
  font-weight: 700;
  letter-spacing: 0.25px;
  margin: 0;
  opacity: 1;
  text-align: initial;
  text-transform: none;
  /* \${themeMediaQuery('medium')} { */
  /*   \font-size: 1em; */
  /* \} */
`
